export enum Umspannung {
    HOECHST_ZU_HOCH_SPANNUNG = 'HOECHST_ZU_HOCH_SPANNUNG',
    HOCH_ZU_MITTEL_SPANNUNG = 'HOCH_ZU_MITTEL_SPANNUNG',
    MITTEL_ZU_NIEDER_SPANNUNG = 'MITTEL_ZU_NIEDER_SPANNUNG'
}

export class UmspannungItem {

    public key: string;
    public description: string;

    constructor(key: string, description: string) {
        this.key = key;
        this.description = description;
    }

    public static getAll(): UmspannungItem[] {
        return [
            new UmspannungItem(Umspannung.HOECHST_ZU_HOCH_SPANNUNG, 'Hös/HS Umspannung'),
            new UmspannungItem(Umspannung.HOCH_ZU_MITTEL_SPANNUNG , 'HS/MS Umspannung'),
            new UmspannungItem(Umspannung.MITTEL_ZU_NIEDER_SPANNUNG , 'MS/NS Umspannung'),
        ];
    }

}

